var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddColleges(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.379,
    height: 17.379,
    viewBox: "0 0 17.379 17.379",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_new_1887063",
    transform: "translate(-2.5 -2.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_64091",
    "data-name": "Path 64091",
    d: "M16.989,2.5H5.39A2.9,2.9,0,0,0,2.5,5.39v11.6a2.9,2.9,0,0,0,2.89,2.89h11.6a2.9,2.9,0,0,0,2.89-2.89V5.39A2.9,2.9,0,0,0,16.989,2.5Zm-1.7,9.678h-3.11v3.11a.328.328,0,0,1-.329.329H10.513a.328.328,0,0,1-.329-.329v-3.11H7.074a.328.328,0,0,1-.329-.329V10.513a.328.328,0,0,1,.329-.329h3.11V7.074a.328.328,0,0,1,.329-.329h1.335a.328.328,0,0,1,.329.329v3.11h3.11a.328.328,0,0,1,.329.329v1.335A.328.328,0,0,1,15.288,12.178Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddColleges);
export default __webpack_public_path__ + "static/media/add-colleges.e84509347b7a959e4e651cca3e981e62.svg";
export { ForwardRef as ReactComponent };